/**
 * GEMMOLOG STEPS
 * ---------------------------------------------------------------------------------------------
 * Nawigacja tasmy krokow na waskim ekranie: strzalki + kropki.
 *
 * Pozycja jest czytana z `scrollLeft`, a nie trzymana w zmiennej - dzieki temu przesuniecie
 * palcem i klikniecie strzalki zawsze pokazuja ten sam stan. Na desktopie tasma jest zwykla
 * siatka (brak przewijania), wiec nawigacja jest ukryta CSS-em i nic nie robi.
 */
(function () {
  'use strict';

  if (window.customElements.get('gemmolog-steps')) return;

  window.customElements.define('gemmolog-steps', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gm-steps-track]');
      this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-gm-step]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-gm-steps-dot]'));
      this.prev = this.querySelector('[data-gm-steps-prev]');
      this.next = this.querySelector('[data-gm-steps-next]');

      if (!this.track || this.steps.length < 2) return;

      this._onScroll = this.sync.bind(this);
      this.track.addEventListener('scroll', this._onScroll, { passive: true });

      if (this.prev) this.prev.addEventListener('click', this.go.bind(this, -1));
      if (this.next) this.next.addEventListener('click', this.go.bind(this, 1));

      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          this.scrollTo(parseInt(dot.dataset.index, 10) || 0);
        }.bind(this));
      }.bind(this));

      /* Klawiatura: strzalki dzialaja, gdy tasma ma fokus. */
      this.track.setAttribute('tabindex', '0');
      this.track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.go(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(-1); }
      }.bind(this));

      this.sync();
    }

    disconnectedCallback() {
      if (this.track && this._onScroll) this.track.removeEventListener('scroll', this._onScroll);
    }

    /* Indeks kroku najblizszego lewej krawedzi widocznego obszaru. */
    current() {
      var left = this.track.scrollLeft;
      var best = 0;
      var bestDistance = Infinity;

      this.steps.forEach(function (step, index) {
        var distance = Math.abs(step.offsetLeft - this.track.offsetLeft - left);
        if (distance < bestDistance) { bestDistance = distance; best = index; }
      }.bind(this));

      return best;
    }

    scrollTo(index) {
      var target = this.steps[Math.max(0, Math.min(index, this.steps.length - 1))];
      if (!target) return;
      this.track.scrollTo({
        left: target.offsetLeft - this.track.offsetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    go(direction) {
      this.scrollTo(this.current() + direction);
    }

    sync() {
      var index = this.current();

      this.dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });

      /* Wylaczamy strzalke na koncu tasmy - inaczej klikanie w nic wyglada jak awaria. */
      var maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 0;
      if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll;
    }
  });
})();
